import api from '@/plugins/api'
import { siteNotification } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
const store = 'notification'

export default {
  state: () => ({
    notificationList: {},
    notification: {}
  }),
  mutations: {
    DELETE_NOTIFICATION (state, payload) {
      state.notificationList.results = state.notificationList.results.filter(item => item.id !== payload)
    }
  },
  actions: {
    async getNotificationList (context, filter) {
      const params = new URLSearchParams()
      for (let field in filter) {
        filter[field] && params.append(field, filter[field])
      }
      const response = await api.get(`${siteNotification.notification}?${params}`)

      if (await requestValidation(response)) {
        context.commit('SET_DATA', {store, state: 'notificationList', data: response.data})
      }
    },

    async getNotification (context, id) {
      const response = await api.get(`${siteNotification.notification}${id}/`)

      if (await requestValidation(response)) {
        context.commit('SET_DATA', {store, state: 'notification', data: response.data})
        context.commit('DELETE_NOTIFICATION', response.data.id)
      }
    },

    async readAllNotification (context) {
      const response = await api.post(`${siteNotification.notification}mark_as_read/`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', {store, state: 'notificationList', data: { count: 0, results: [] }})
      }
    }
  }
}
